import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import { Link } from "react-router-dom"
import { Collapse, Switch } from "antd"

const UpdateSkillsPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [haveWorkExp, setHaveWorkExp] = useState(true)
    const { Panel } = Collapse
    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }


    return (
        <Navbar active={"My jobs"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white font-bold py-4 w-full">Update skills</h1>
            </div>
            <div className="relative top-14">
                <div className="px-5 lg:px-8 mt-3">
                    <div className="flex gap-x-1 mb-3">
                        <Link className="underline hover:underline text-cyan-700">
                            Checklists
                        </Link>
                        <span>
                            /
                        </span>
                        <strong className="font-medium">
                            Update skills
                        </strong>
                    </div>
                    <div>
                        <h1 className="font-bold text-lg">
                            Critical Care/ICU
                        </h1>
                        <button className="bg-cyan-100 rounded p-1 text-[#515495] text-xs mt-3">
                            Recommended
                        </button>
                        <p className="mt-2 text-[12px]">
                            Please complete the following checklist based on your experience with each skill.
                        </p>
                    </div>

                    <div className="flex gap-x-2 mt-6" >
                        <div className="w-full p-3 rounded-lg" style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}>
                            <div>
                                <ul className="list-decimal text-[12px] list-inside flex flex-col gap-y-1">
                                    <li>I've nevver done this</li>
                                    <li>I can perform this with guidance from someone</li>
                                    <li>I am competent with this and can perform it solo</li>
                                    <li>
                                        I am highly proficient with this and could teach it to others
                                    </li>
                                </ul>
                            </div>
                            <div className="">
                                <Collapse className="border-0 shadow-none bg-transparent">
                                    <Panel className="font-semibold border-0 shadow-none  bg-transparent !rounded-none" key={"1"} header="WORK SETTINGS*">
                                        <div className="flex justify-between">
                                            <label className="font-semibold">
                                                I have experience in this skill set
                                            </label>
                                            <Switch checked={haveWorkExp} onChange={(e) => setHaveWorkExp(e)} className="bg-gray-300" />
                                        </div>
                                        <div className="px-1 mt-5">
                                            <div className="flex gap-x-8 justify-end">
                                                <span>1</span>
                                                <span>2</span>
                                                <span>3</span>
                                                <span>4</span>
                                            </div>
                                            <div className="flex justify-between py-1">
                                                <span>
                                                    Burn Intensive Care Unit
                                                </span>
                                                <div className="flex gap-x-[22px]">
                                                    <input type="radio" name="burn-intensive" id="" />
                                                    <input type="radio" name="burn-intensive" id="" />
                                                    <input type="radio" name="burn-intensive" id="" />
                                                    <input type="radio" name="burn-intensive" id="" />
                                                </div>
                                            </div>
                                            <div className="flex justify-between py-1">
                                                <span>
                                                    Cardiac Intensive Care Unit
                                                </span>
                                                <div className="flex gap-x-[22px]">
                                                    <input type="radio" name="cardiac-intensive" id="" />
                                                    <input type="radio" name="cardiac-intensive" id="" />
                                                    <input type="radio" name="cardiac-intensive" id="" />
                                                    <input type="radio" name="cardiac-intensive" id="" />
                                                </div>
                                            </div>
                                            <div className="flex justify-between py-1">
                                                <span>
                                                    Cardiovascular Intensive Care Unit (CVICU)
                                                </span>
                                                <div className="flex gap-x-[22px]">
                                                    <input type="radio" name="cardiovascular-intensive" id="" />
                                                    <input type="radio" name="cardiovascular-intensive" id="" />
                                                    <input type="radio" name="cardiovascular-intensive" id="" />
                                                    <input type="radio" name="cardiovascular-intensive" id="" />
                                                </div>
                                            </div>
                                                <div className="flex justify-between py-1">
                                                    <span>
                                                    Cardiac Cath Lab
                                                    </span>
                                                    <div className="flex gap-x-[22px]">
                                                        <input type="radio" name="cardiac-cath-lab" id="" />
                                                        <input type="radio" name="cardiac-cath-lab" id="" />
                                                        <input type="radio" name="cardiac-cath-lab" id="" />
                                                        <input type="radio" name="cardiac-cath-lab" id="" />
                                                    </div>
                                                </div>
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>
                        </div>




                        <div className="w-full">

                        </div>
                    </div>

                </div>
            </div>
        </Navbar>
    )
}

export default UpdateSkillsPage